export interface DaySchedule {
  is_active?: number | boolean;
  all_day?: number | boolean;
  from?: string;
  to?: string;
}

export interface WeekSchedule {
  weekdays?: DaySchedule;
  weekends?: DaySchedule;
  holidays?: DaySchedule;
}

/** Legacy `scheduleDestructure`: "не работает" / "круглосуточно" / "09:00 - 18:00". */
export const formatDaySchedule = (day?: DaySchedule): string => {
  if (!day?.is_active) return 'не работает';
  if (day.all_day) return 'круглосуточно';
  if (day.from && day.to) return `${day.from.replace('-', ':')} - ${day.to.replace('-', ':')}`;
  return '';
};
